export interface StockItemAllocation {
  id: string;
  stockItemId: string;
  stockNo: string;
  productKey: string;
  productDescription: string;
  productType: string;
  customerKey: string;
  customerName: string;
  orderNo: string;
  allocationType: string;
  allocated: number;
  allocatedImperial: number;
  orderQuantity: number;
  deliveryDate: Date;
  selected: boolean;
}
